/**
 * @desc loadUserByAdapter
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.Code, options?: any) {
  return updateResponse(
    http(URL + `/load/user`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
